import React, { ComponentState, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { ClientService } from "src/services/clientService";
import APP_ROUTES from "src/helper/app-routes";
import { renderErrors } from "src/helper/error-message-helper";
import NotificationManager from "react-notifications/lib/NotificationManager";

import { NichqHeader } from "./Nichq-heads";  






export const WCC_Scale = ({ WCC,   response, interfered, isPrint, questionId }) => {
 
  const { state } = useLocation();
  const selectedClientId = useSelector((state: ComponentState) => state.selectedClientId);
  const navigate = useNavigate(); 
 
  const [wcc, setWcc] = useState<any[]>([]); 
 


  useEffect(() => {

    const Wcc = WCC.map((item) => {
      const foundItem = response.find((i) => i.questionId === item.questionId);
      if (foundItem) {
        if (item.type === "question") {
          if (foundItem.value) {
            return { ...item, isSelected: true, value: foundItem.value };
          } else {
            return { ...item, isSelected: false, value: "" };
          }
        }
        return { ...item, ...foundItem };
      } else {
        return item;
      }
    });   

     
    setWcc(Wcc); 

     



  }, [response])

  const handleSubmit = async () => {
    await ClientService.insertClientQuestionnaire(
      selectedClientId, 0,
      [ 
        ...wcc, 
      ],
      questionId
    )
      .then((result) => {
        let questionList = result.resultData;
        navigate(APP_ROUTES.QUESTIONNAIRE);
        NotificationManager.success("Add successfully");
      })
      .catch((error) => {
        // setLoading(false);
        renderErrors(error.message);
      });
  }; 

  return (
    <div className="ml-3">
      
      <div className="mt-4 head-4">
        Borderline Symptom List 23 (BSL-23)
      </div>

 
      {
        wcc.length > 0 &&
        <div className="row mt-4">
          <NichqHeader

            title={""}
            disabled={response && response.length > 0}
            subTitle={''}
            listItems={wcc}
            setListItems={setWcc}
          />
        </div>
      } 
 



      {state == null && !isPrint ? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleSubmit} className="submit_phq ">
            Submit
          </button>
        </div>
      ) : (
        ""
      )}






    </div>

  )

} 



